// extracted by mini-css-extract-plugin
module.exports = {"container":"Faq_container__L_CD4","questions":"Faq_questions__A00TU","questions--limited":"Faq_questions--limited__oVHKD","button":"Faq_button__28xDE"};